import { IAction } from "bee-library-api-client"

export enum RoomActionCode {
    SHOW_SECRET_ROOM = "show-secret-rooms",
    CREATE_ROOM = "create-room",
    INIT_ROOM_CONFERENCE = "init-room-conference",
    DELETE_ROOM = "delete-room",
    UPDATE_ALIAS_ROOM = "update-alias-room",
}

export enum ROOM_VISIBILITY_TYPE {
    PUBLIC = "public",
    SECRET = "secret",
}

export interface IRoomStatus {
    nbParticipants: number
    hasModerator: boolean
}

export interface IRoom {
    roomId: string
    alias: string
    visibility: ROOM_VISIBILITY_TYPE
    conference: {
        status: IRoomStatus | null
        nbParticipantsMax: number
    }
    $actions: IAction<RoomActionCode>[]
}

export interface IRoomsList {
    rooms: IRoom[]
    $actions: IAction<RoomActionCode>[]
}
